import { type ReactNode } from 'react';
import cx from 'clsx';
import { Topbar } from '../../topbar/topbar';
import { DropdownLanguage } from '../../dropdown-language/dropdown-language';
import styles from './main-layout.module.css';

interface MainLayoutProps {
  children: ReactNode;
  mobileAsBlock?: boolean;
  promoBanner?: ReactNode | null;
}

export function MainLayout({ children, mobileAsBlock, promoBanner }: MainLayoutProps): ReactNode {
  return (
    <main
      className={cx(
        promoBanner ? styles.mainWrapperPromoBanner : styles.mainWrapper,
        mobileAsBlock && styles.mobileAsBlock
      )}
    >
      {promoBanner ? promoBanner : null}
      <Topbar />
      {children}
      <footer className={`${styles.footer} hide-on-desktop`}>
        <DropdownLanguage data-test-register-signup-topbar-language-dd />
      </footer>
    </main>
  );
}
